'use strict';

(function () {
  'use strict';

  angular.module('vnext').factory('memberMessagesSvc', memberMessagesSvc);

  memberMessagesSvc.$inject = ['httpSvc'];

  /* @ngInject */
  function memberMessagesSvc(httpSvc) {

    return {
      getMessages: getMessages
    };

    function getMessages() {
      return httpSvc.get('/apiproxy/user/member/messages');
    }
  }
})();